// extracted by mini-css-extract-plugin
export default {"navbar":"Navbar_navbar__OD26C","navbarItem":"Navbar_navbarItem__TAHU0","active":"Navbar_active__oiOd0"};